var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropRugby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.41px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.37,
    y1: 91.99,
    x2: 54.37,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 95.63,
    y1: 91.99,
    x2: 95.63,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.87,
    y: 75.8,
    width: 7.52,
    height: 16.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.61,
    y: 75.8,
    width: 7.52,
    height: 16.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.37,
    y1: 67.92,
    x2: 95.63,
    y2: 67.92
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.81,28.64h8.61c1.7,0,3.07.23,4.11.69,1.04.46,1.91,1.12,2.59,1.98.68.86,1.18,1.86,1.48,3,.31,1.14.46,2.35.46,3.63,0,2-.23,3.56-.68,4.66-.46,1.1-1.09,2.03-1.9,2.78-.81.75-1.68,1.24-2.61,1.49-1.27.34-2.42.51-3.45.51h-8.61v-18.75ZM72.61,32.89v10.24h1.42c1.21,0,2.07-.13,2.58-.4.51-.27.91-.74,1.2-1.41.29-.67.44-1.75.44-3.25,0-1.99-.32-3.35-.97-4.08-.65-.73-1.72-1.1-3.22-1.1h-1.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropRugby);
export default __webpack_public_path__ + "static/media/drop_rugby.7e4f1e268cb7e67608c67e070f409e5d.svg";
export { ForwardRef as ReactComponent };